export default "__VITE_ASSET__e8707a82__"